
import DataHelpers from './DataHelpers'
import Utilities from './Utilities'
import Vue from 'vue'


export default class {

    static unshiftUnique(array, object) {
        const idx = array.findIndex(o => o.key == object.key)
        if(idx == -1)
            array.unshift(object)
    }

    static prepareSave(obj) {
        let newObj = {...obj}
        if(!newObj.key){
            newObj.key = DataHelpers.getKey()
        }
        newObj.stamp = DataHelpers.getStamp()  
        return newObj      
    }

    // static save(obj, arr, position) {
    //     let idx = arr.findIndex(o => o.key == obj.key)
    //     if(idx >=0) {
    //         let existingObj = arr[idx]
    //         let newObj = Object.assign({}, existingObj, obj)
    //         Vue.set(arr, idx, newObj)
    //     } else {
    //         let newObj = {...obj}
    //         if(position === 0)
    //             arr.unshift(newObj)
    //         else
    //             arr.push(newObj)
    //     }
    // }
    
    static save(obj, arr, position) {
        if(this.update(obj, arr)) 
            return
            
        let newObj = {...obj}
        if(position === 0)
            arr.unshift(newObj)
        else
            arr.push(newObj)
       
    }

    static update(obj, arr) {
        let idx = arr.findIndex(o => o.key == (obj.key || obj.meta.key))
        if(idx >=0) {
            let existingObj = arr[idx]
            let newObj = Object.assign({}, existingObj, obj)
            Vue.set(arr, idx, newObj)
            return true
        } else
            return false        
    }


    //to remove later?
    static saveToArray(obj, arr, position) {
        let newObj = Object.assign({}, obj)
        newObj.key = DataHelpers.getKey()
        newObj.stamp = DataHelpers.getStamp()
        if(position == 0)
            arr.unshift(newObj)
        else
            arr.push(newObj)
        return newObj
    }

    static delete(obj, arr) {
        //Utilities.log('ListHelpers > delete')
    
        let idx = arr.findIndex(o => o.key == (obj.key || obj.meta.key) )
        if(idx >= 0)
            arr.splice(idx, 1)
        else
            Utilities.log('ListHelpers > delete > Cant find object', obj)
    }

    static selectSingle(obj, array) {
        let previouslySelected = Boolean(obj.selected)

        this.unselectAll(array)
        this.changeSelection(obj, !previouslySelected)
    }
    
    static selectMulti(obj) {
        this.changeSelection(obj)
    }

    static selectRange(obj, array) {
        let selectedItems = this.getSelectedItems(array)
        if(selectedItems.length < 1) {
            this.changeSelection(obj)
            return 
        }
        let lastSelected = selectedItems[selectedItems.length - 1]
        let index1 = array.indexOf(lastSelected)
        let index2 = array.indexOf(obj)

        let lowerIndex = Math.min(index1, index2)
        let upperIndex = Math.max(index1, index2)

        for(var n = lowerIndex; n <= upperIndex; n++) {
            let obj = array[n]
            this.changeSelection(obj, true)
        }
    }    

    static changeSelection(obj, value) {
        if(value == null)
            value = !Boolean(obj.selected)

        Vue.set(obj, 'selected', value)    
    }

    static getSelectedItems(array) {
        return array.filter(o => o.selected)
    }

    static unselectAll(array) {
        this.getSelectedItems(array).forEach(item => {
            this.changeSelection(item, false)
        })
    }

    static selectedOrClicked(obj, selectedObjects) {
        let idx = selectedObjects.findIndex(o => o.key == obj.key)
        if(idx >= 0) 
            return selectedObjects
        else
            return [obj]
    }


}


// WEBPACK FOOTER //
// ./src/helpers/ListHelpers.js